import { ApplicationRole } from "../../../../../api/models/ApplicationRole";
import { LeadType } from "../../shared/Constants";

import AttorneyApprovalActions from "./AttorneyApprovalActions";
import { LeadViewModel } from "../../../../../api";
import AdminActions from "./AdminActions";

interface LeadMenuProps {
  leadType: LeadType;
  userRoles?: ApplicationRole[];
  details?: LeadViewModel;
}

export default function LeadMenu(props: LeadMenuProps) {
  return (
    <>
      <AdminActions
        leadType={props.leadType}
        userRoles={props.userRoles}
        details={props.details}
      />
      <AttorneyApprovalActions
        leadType={props.leadType}
        userRoles={props.userRoles}
        details={props.details}
      />
    </>
  );
}
